export default __webpack_public_path__ + "static/media/video-conference.43db4fe3.svg";